<div class="main-page-section default_font pt-3 pt-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-food-vendor/{{foodCourtId}}">View Vendors</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev">Vendor Details</span>
        </div>

        <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
                <h2 class="font-weight-bold mb-3 mb-md-4">Vendor Details</h2>
                <button class="btn btn-primary" (click)="listFoodMenuSection(vendorId)" *ngIf="foodvendorView">View Menu</button>
                <!-- <button class="btn btn-primary" (click)="addFoodMenuSection(vendorId)">Add Menu</button> -->
            </div>
            <h5 class="text-primary font-weight-semibold" style="color: #004988;">Food Court Name:
                {{vendorDetails?.data.foodCourtName}}</h5>
        </div>

        <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <h6 class="font-weight-bold mb-3 mb-md-4">Name and Branding</h6>
            <h6 class="font-weight-semibold">Name: {{vendorDetails?.data.foodCourtVendorName}}</h6>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                *ngFor="let brandimage of vendorDetails?.data.foodCourtVendorPhotos">
                <div class="image_card">
                    <img [src]="brandimage?.foodCourtVendorPhotoPath" [alt]="vendorlogo" [title]="vendorlogo">
                </div>
            </div>
        </div>

        <h6
            class="pt-3 pt-md-4 pt-lg-5 pt-xl-6 mb-3 mb-md-4 border-top mt-3 mt-md-4 d-flex align-items-center column-gap-12">
            Days of Operation</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium ">From</small>
                <!-- <span class="font-weight-medium text-gray-dark">{{vendorDetails?.data.fromDaysOperation}}</span> -->
                <span class="font-weight-medium text-gray-dark">{{vendorDetails?.data.fromDay}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">To</small>
                <!-- <span class="font-weight-medium text-gray-dark">{{vendorDetails?.data.toDaysOperation}}</span> -->
                <span class="font-weight-medium text-gray-dark">{{vendorDetails?.data.toDay}}</span>
            </div>
        </div>

        <h6
            class="pt-3 pt-md-4 pt-lg-5 pt-xl-6 mb-3 mb-md-4 border-top mt-3 mt-md-4 d-flex align-items-center column-gap-12">
            Time of Operation</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium ">From</small>
                <span class="font-weight-medium text-gray-dark">{{vendorDetails?.data.fromTimeOperation}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">To</small>
                <span class="font-weight-medium text-gray-dark">{{vendorDetails?.data.toTimeOperation}}</span>
            </div>
        </div>

        <form [formGroup]="Form">
            <div
                class="pt-3 pt-md-4 pt-lg-5 pt-xl-6 mb-3 mb-md-4 border-top mt-3 mt-md-4 d-flex align-items-center column-gap-12">
                <h3 class="font-weight-semibold mb-0">Mark as Closed</h3>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="ismarkAsClosed"
                        formControlName="ismarkAsClosed" [(ngModel)]="ismarkAsClosed"
                        (change)="markTheVendorOpenClose($event)">
                    <label class="custom-control-label" for="ismarkAsClosed"></label>
                </div>
            </div>
        </form>
    </div>
    <div
        class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
        <button class="btn btn-clear text-danger" (click)="openModalRemoveVendor(vendorId)" *ngIf="foodvendorRemove">Delete</button>
        <button class="btn btn-clear" (click)="gotoReviewPage(vendorId)" *ngIf="foodvendorView">See Reviews</button>
        <button class="btn btn-primary" (click)="goToEditPage(vendorId)" *ngIf="foodvendorEdit">Edit Details</button>
    </div>
</div>